/* global fetch */

import { config } from '../config';
import { APIResponse, fetchAPI, headers, SpanTag, stleaf } from '../helpers';


export const getAllFeatures = (
  st: SpanTag,
) => {
  const url = new URL(`${config.API_URL}/v1/features/`);
  return fetchAPI(stleaf(st, 'getfts'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getOrganisationFeatures = (
    st: SpanTag,
    organisationId: string,
  ) => {
    const url = new URL(`${config.API_URL}/v1/features/${organisationId}`);
    return fetchAPI(stleaf(st, 'getoft'), url, {
      method: 'GET',
      credentials: 'include',
      headers,
    });
  };

